export const FJ_EVENT_TYPE = {
    HIDE_QUICK_SELECTION_BOX: 'HIDE_QUICK_SELECTION_BOX',
    HIDE_SIDE_MODAL: 'HIDE_SIDE_MODAL',

    START_RECORDER: 'START_RECORDER',
};
